import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminGuard } from './core/guards/admin.guard';
import { ModuleGuard } from './core/guards/module.guard';
import { DashboardRedirectGuard } from './core/guards/dashboard-redirect.guard';
import { DashboardComponent } from './features/dashboard/dashboard.component';
// import { LoginPageComponent } from './features/auth/pages/login-page/login-page.component';
import { ProtectedLayoutComponent } from './features/layout/protected-layout.component';
import { LoginPageComponent } from './features/auth/pages/login-page.component';
import { CHAT_ROUTES } from './features/chat/chat.routes';
export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    component: ProtectedLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [DashboardRedirectGuard],
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes').then((m) => m.usersRoutes),
        canActivate: [ModuleGuard],
        data: { moduleKey: 'users' },
      },
      {
        path: 'guards',
        loadChildren: () => import('./features/guards/guards.routes').then((m) => m.guardsRoutes),
        canActivate: [ModuleGuard],
        data: { moduleKey: 'guards' },
      },
      {
        path: 'positions',
        loadChildren: () =>
          import('./features/positions/positions.routes').then((m) => m.positionsRoutes),
        canActivate: [ModuleGuard],
        data: { moduleKey: 'positions' },
      },
      {
        path: 'devices',
        loadChildren: () =>
          import('./features/devices/devices.routes').then((m) => m.devicesRoutes),
        canActivate: [ModuleGuard],
        data: { moduleKey: 'devices' },
      },
      {
        path: 'access-requests',
        loadChildren: () =>
          import('./features/access-requests/access-requests.routes').then(
            (m) => m.accessRequestsRoutes,
          ),
        canActivate: [ModuleGuard],
        data: { moduleKey: 'accessRequests' },
      },
      {
        path: 'checkins',
        loadChildren: () =>
          import('./features/checkins/checkins.routes').then((m) => m.checkinsRoutes),
        canActivate: [ModuleGuard],
        data: { moduleKey: 'checkins' },
      },
      {
        path: 'supervision',
        loadComponent: () =>
          import('./features/supervision/supervision.component').then(
            (m) => m.SupervisionComponent,
          ),
        canActivate: [ModuleGuard],
        data: { moduleKey: 'supervision' },
      },
      {
        path: 'patrols',
        loadChildren: () =>
          import('./features/patrols/patrols.routes').then((m) => m.patrolsRoutes),
        canActivate: [ModuleGuard],
        data: { moduleKey: 'patrols' },
      },
      {
        path: 'relief-guards',
        loadComponent: () =>
          import('./features/relief-guards/relief-guard-list.component').then(
            (m) => m.ReliefGuardsListComponent,
          ),
        canActivate: [ModuleGuard],
        data: { moduleKey: 'reliefGuards' },
      },
      {
        path: 'sigos-absences',
        loadComponent: () =>
          import('./features/sigos-absence/sigos-absence-list.component').then(
            (m) => m.SigosAbsencesListComponent,
          ),
        canActivate: [ModuleGuard],
        data: { moduleKey: 'sigos' },
      },
      {
        path: 'admin',
        loadComponent: () =>
          import('./features/admin/components/admin-panel/admin-panel.component').then(
            (m) => m.AdminPanelComponent,
          ),
        canActivate: [AdminGuard],
      },
      {
        path: 'chat',
        loadChildren: () => import('./features/chat/chat.routes').then((m) => m.CHAT_ROUTES),
      },
    ],
  },
  {
    path: 'public/patrol-routes/:uuid/records',
    loadComponent: () =>
      import('./features/public/components/public-patrol-records/public-patrol-records.component').then(
        (m) => m.PublicPatrolRecordsComponent,
      ),
    title: 'Histórico de Patrulhas - SMV',
  },
  {
    path: 'public/positions/:uuid/check-ins',
    loadComponent: () =>
      import('./features/public/components/public-position-checkins/public-position-checkins.component').then(
        (m) => m.PublicPositionCheckinsComponent,
      ),
    title: 'Histórico de Marcações de Presença - SMV',
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
